import { render, staticRenderFns } from "./WikiConfigView.vue?vue&type=template&id=8314a760&scoped=true"
import script from "./WikiConfigView.vue?vue&type=script&lang=js"
export * from "./WikiConfigView.vue?vue&type=script&lang=js"
import style0 from "./WikiConfigView.vue?vue&type=style&index=0&id=8314a760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8314a760",
  null
  
)

export default component.exports